"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const notavailable = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    "aria-labelledby": (title ? `title-notavailable` : '') + (description ? ` desc-notavailable` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-notavailable"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-notavailable"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ulta_not_available",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Semantic-Badge"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    id: "Badge",
    fill: "#D4D4D4",
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "Icon",
    transform: "translate(1.393398, 1.393398)",
    fill: "#000000"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5337135,3.11080655 C10.2228768,3.14690974 9.98160172,3.41107932 9.98160172,3.73160172 L9.98126838,9.98126838 L3.73160172,9.98160172 L3.65822138,9.98616165 C3.33886784,10.0291008 3.10660172,10.2929634 3.10660172,10.6066017 L3.11080655,10.6794899 C3.14690974,10.9903266 3.41107932,11.2316017 3.73160172,11.2316017 L9.98126838,11.2312684 L9.98160172,17.4816017 L9.98616165,17.5549821 C10.0291008,17.8743356 10.2929634,18.1066017 10.6066017,18.1066017 L10.6794899,18.1023969 C10.9903266,18.0662937 11.2316017,17.8021241 11.2316017,17.4816017 L11.2312684,11.2312684 L17.4816017,11.2316017 L17.5549821,11.2270418 C17.8743356,11.1841026 18.1066017,10.9202401 18.1066017,10.6066017 L18.1023969,10.5337135 C18.0662937,10.2228768 17.8021241,9.98160172 17.4816017,9.98160172 L11.2312684,9.98126838 L11.2316017,3.73160172 L11.2270418,3.65822138 C11.1841026,3.33886784 10.9202401,3.10660172 10.6066017,3.10660172 L10.5337135,3.11080655 Z",
    id: "Icon-Color",
    transform: "translate(10.606602, 10.606602) rotate(45.000000) translate(-10.606602, -10.606602) "
  }))))));
};
var _default = exports.default = notavailable;